import { Dispatch } from "redux";
import {
  ERROR_LOADING_DYNAMIC_FORMS,
  GET_ALL_FORMS,
  RESET_DATA,
  START_LOADING_DYNAMIC_FORMS,
  STOP_LOADING_DYNAMIC_FORMS,
} from "./action-types";
import apiLibrary from "services/api";
import { generateQueryStringForUsers } from "utils/convertFiltersToQueryString";
import { Toasts } from "view/components/Toasts";

export const fetchDynamicFormsAction =
  (communityId?: any, programId?: any) =>
  async (dispatch: Dispatch, getState: any) => {
    // dispatch(loadingState(true))
    dispatch({ type: START_LOADING_DYNAMIC_FORMS });
    // dispatch(setLoadingProgress(getRandomProgress()));
    try {
      const currentState = getState();

      const params = generateQueryStringForUsers(
        currentState.Filters.dynamicFormsFilter
      );
      const query = appendCommunityAndProgramIdInParams(
        communityId,
        programId,
        params
      );
      const { data } = await apiLibrary.Forms.getAllForms(query);
      dispatch({
        type: GET_ALL_FORMS,
        payload: data,
      });
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);

      dispatch({
        type: RESET_DATA,
      });
      console.log("An error occurred while fetching the user profile:", error);
      // dispatch(fetchError(error))
      dispatch({ type: ERROR_LOADING_DYNAMIC_FORMS });
    } finally {
      dispatch({ type: STOP_LOADING_DYNAMIC_FORMS });
      // dispatch(setLoadingProgress(100));
      // dispatch(loadingState(false))
    }
  };

const appendCommunityAndProgramIdInParams = (
  communityId: any,
  programId: any,
  params: any
) => {
  let updatedParams = { ...params };

  if (programId) {
    updatedParams.programIds = programId.toString();
  }
  if (communityId) {
    updatedParams.communityIds = communityId.toString();
  }

  return updatedParams;
};
